import { render, staticRenderFns } from "./Databases.vue?vue&type=template&id=d501941c&"
import script from "./Databases.vue?vue&type=script&lang=js&"
export * from "./Databases.vue?vue&type=script&lang=js&"
import style0 from "./Databases.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports